import { Star } from "lucide-react";
import { useState } from "react";

/**
 * StarRating
 * - display mode: shows filled/empty stars + numeric avg + count
 * - interactive mode (onChange): click to set rating
 */
export const StarRating = ({
  rating = 0,
  count = null,
  size = 16,
  interactive = false,
  onChange = null,
  showNumber = true,
  className = "",
}) => {
  const [hover, setHover] = useState(0);
  const stars = [1, 2, 3, 4, 5];
  const active = (i) => (interactive ? (hover || rating) >= i : rating >= i - 0.25);

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="skill-rating">
      <div className="flex items-center gap-0.5">
        {stars.map((i) => (
          <button
            key={i}
            type="button"
            disabled={!interactive}
            onMouseEnter={() => interactive && setHover(i)}
            onMouseLeave={() => interactive && setHover(0)}
            onClick={() => interactive && onChange && onChange(i)}
            className={interactive ? "cursor-pointer transition-transform hover:scale-110" : "cursor-default"}
            aria-label={`${i} star${i > 1 ? "s" : ""}`}
            data-testid={interactive ? `star-input-${i}` : undefined}
          >
            <Star
              style={{ width: size, height: size }}
              className={
                active(i)
                  ? "fill-[color:var(--rb-gold)] text-[color:var(--rb-gold)]"
                  : "text-[color:rgba(212,175,55,0.28)]"
              }
            />
          </button>
        ))}
      </div>
      {showNumber && (
        <span className="text-sm text-[color:var(--rb-text-dim)] tabular-nums">
          {Number(rating || 0).toFixed(1)}
          {count !== null && (
            <span className="text-[color:var(--rb-text-faint)]" data-testid="skill-rating-count">
              {" "}({count})
            </span>
          )}
        </span>
      )}
    </div>
  );
};
